import {
  useEnginePagination,
  UseEnginePaginationSelector
} from '@surveycake/react-logic-engine';
import { Progress } from 'app/shared/components';
import React from 'react';
import * as styles from './styles';

const progressSelector: UseEnginePaginationSelector<number> = pagination =>
  pagination.progress;

function SurveyProgress() {
  const percentage = useEnginePagination(progressSelector);

  return (
    <div className={styles.surveyProgress}>
      <Progress percentage={percentage} />
    </div>
  );
}

export default SurveyProgress;
